import { useState } from "react";
import api, { apiErr } from "../../lib/api";
import { Input } from "../../components/ui/input";
import { Label } from "../../components/ui/label";
import { Button } from "../../components/ui/button";
import { toast } from "sonner";
import { KeyRound, Save } from "lucide-react";

export const ChangePassword = () => {
  const [form, setForm] = useState({ current_password: "", new_password: "", confirm_password: "" });
  const [saving, setSaving] = useState(false);
  const up = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const submit = async (e) => {
    e.preventDefault();
    if (form.new_password !== form.confirm_password) {
      toast.error("La nuova password e la conferma non coincidono.");
      return;
    }
    if (form.new_password.length < 12) {
      toast.error("La nuova password deve contenere almeno 12 caratteri.");
      return;
    }
    setSaving(true);
    try {
      await api.post("/auth/change-password", form);
      toast.success("Password aggiornata correttamente.");
      setForm({ current_password: "", new_password: "", confirm_password: "" });
    } catch (err) {
      toast.error(apiErr(err));
    } finally {
      setSaving(false);
    }
  };

  const inputCls = "h-11 bg-white border-[#DDE5E2]";

  return (
    <div data-testid="change-password-page" className="max-w-md">
      <h1 className="text-2xl font-semibold text-[#2B3A42] mb-1 flex items-center gap-2">
        <KeyRound className="h-5 w-5 text-[#6C8EAD]" /> Cambia password
      </h1>
      <p className="text-sm text-[#5B6E78] mb-6">
        Imposta una nuova password per l'account amministratore (minimo 12 caratteri).
      </p>
      <form onSubmit={submit} className="bg-white rounded-2xl border border-[#DDE5E2] p-6 space-y-4">
        <div className="space-y-1.5">
          <Label className="text-sm text-[#2B3A42]">Password attuale</Label>
          <Input data-testid="cp-current" type="password" className={inputCls} value={form.current_password}
            onChange={(e) => up("current_password", e.target.value)} autoComplete="current-password" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-sm text-[#2B3A42]">Nuova password</Label>
          <Input data-testid="cp-new" type="password" className={inputCls} value={form.new_password}
            onChange={(e) => up("new_password", e.target.value)} autoComplete="new-password" />
        </div>
        <div className="space-y-1.5">
          <Label className="text-sm text-[#2B3A42]">Conferma nuova password</Label>
          <Input data-testid="cp-confirm" type="password" className={inputCls} value={form.confirm_password}
            onChange={(e) => up("confirm_password", e.target.value)} autoComplete="new-password" />
        </div>
        <Button data-testid="cp-submit" type="submit" disabled={saving}
          className="w-full h-11 gap-2 rounded-full bg-[#6C8EAD] hover:bg-[#4F708C] text-white">
          <Save className="h-4 w-4" /> {saving ? "Salvataggio..." : "Aggiorna password"}
        </Button>
      </form>
    </div>
  );
};
